export default function () {

    (function($) {

        /**
         * @param {bool} loading
         */
        $.fn.setLoading = function(loading) {
            if (!loading) {
                $(this).find('.spinner').remove();

                return;
            }

            $(this).append(
                '<div class="spinner center">' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                    '<div class="spinner-blade"></div>' +
                '</div>'
            );
        };

        $('.btn.loading').setLoading(true);

    })(jQuery);

}
